var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "80px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "审批人", prop: "applyName" } },
            [
              _c("el-autocomplete", {
                staticClass: "inline-input",
                attrs: { "fetch-suggestions": _vm.peopleSearch },
                on: { select: _vm.peopleSelect },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.item.userName))])]
                    },
                  },
                ]),
                model: {
                  value: _vm.dataForm.applyName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "applyName", $$v)
                  },
                  expression: "dataForm.applyName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "审批消息接收", prop: "tipInfo" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.dataForm.tipInfo,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "tipInfo", $$v)
                    },
                    expression: "dataForm.tipInfo",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("公众号")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("邮箱")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("短信")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }